import { useParams } from 'react-router-dom';
import { DELIVERY_TYPES, MESSAGE_TYPES } from '../pages/branding/menu/brandingConfig';

export type MessageType = typeof MESSAGE_TYPES[keyof typeof MESSAGE_TYPES];
export type DeliveryType = typeof DELIVERY_TYPES[keyof typeof DELIVERY_TYPES];

export interface BrandingParams {
    messageType: MessageType;
    deliveryType: DeliveryType;
}

/**
 * Custom hook for managing branding navigation parameters
 * Provides validation, defaults, and type safety for messageType and deliveryType
 */
export const useBrandingParams = (): BrandingParams => {
    const params = useParams();
    
    // Extract and validate messageType
    const messageTypeParam = params.messageType as string;
    const messageType: MessageType = Object.values(MESSAGE_TYPES).includes(messageTypeParam as MessageType)
        ? (messageTypeParam as MessageType)
        : MESSAGE_TYPES.sendTicket;
    
    // Extract and validate deliveryType
    const deliveryTypeParam = params.deliveryType as string;
    const validDeliveryTypes: DeliveryType[] = [DELIVERY_TYPES.email, DELIVERY_TYPES.sms, DELIVERY_TYPES.whatsapp];
    const deliveryType: DeliveryType = validDeliveryTypes.includes(deliveryTypeParam as DeliveryType)
        ? (deliveryTypeParam as DeliveryType)
        : DELIVERY_TYPES.whatsapp;
    
    return {
        messageType,
        deliveryType
    };
};


